import { IncomingMessage } from 'http';

import { QueryFunction, QueryKey } from '@tanstack/react-query';

import fetchProductDetails from '../../../services/products/fetch-details';

const getProductDetails = (
  options: {
    locale: string;
    slug: string;
    shipping_location?: string;
    is_advanced_view?: boolean;
    detailed_prices?: boolean;
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<ReturnType<typeof fetchProductDetails>>] => [
  [
    'user-dependent',
    'product-defails',
    {
      locale: options.locale,
      slug: options.slug,
      is_advanced_view: options.is_advanced_view || false,
      detailed_prices: options.is_advanced_view || false,
    },
  ],
  ({
    queryKey: [, , key],
  }: {
    queryKey: [
      string,
      string,
      {
        locale: string;
        slug: string;
        is_advanced_view: boolean;
        detailed_prices: boolean;
      }
    ];
  }) => fetchProductDetails(options, req),
];

export default getProductDetails;
